import React, { useEffect } from "react";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useGetCorporatePlansSummaryQuery } from "../../../../redux/service/modules/dashboard";
import { useSelector } from "react-redux";
import TableLayout from "../../../../components/layout/TableLayout";

export const PlanSummary = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(["analyst"]);
        return () => {
            setRequiredFilters([]);
        };
    }, []);
    return (
        <TableLayout>
            <PaginatedDataTable
                queryHook={useGetCorporatePlansSummaryQuery}
                initialDateRange={dateRange}
                isColumnSticky={true}
                stickyColumnsCount={2}
                appliedFilters={appliedFilters}
                totalText="Overall Total"
            />
        </TableLayout>
    );
};
